import styled from "styled-components"
import { media } from "../../../../styles"

import { Link } from "gatsby"

export const FooterSection = styled.footer`
  width: 100%;
  position: relative;
  z-index: 1;

  background-color: var(--color-blue);
`
export const FooterContainer = styled.div`
  padding: 15rem;

  display: grid;
  width: 100%;
  max-width: 145rem;
  margin: 0 auto;

  grid-template-columns: 60% 30%;
  column-gap: 10%;

  width: 100%;
  margin: 0 auto;
  max-width: 145rem;
  padding: 10rem 0rem;

  ${media.laptop`
  max-width: 86%;
  `}

  ${media.laptopsmall`
  grid-template-columns: 1fr;
  row-gap: 7.5rem;
  `}

  ${media.tabland`
  max-width: 100%;
  padding: 15rem 13rem;
  row-gap: 5rem;
  `}

  ${media.tabport`

  padding: 10rem 8rem;
  `}

  ${media.phone`

  padding: 10rem 5rem;
  `}

  ${media.phonesmall`
  padding: 10rem 2rem;

  `}
`
export const FooterFormContainer = styled.div`
  ${media.laptopsmall`

  `}
`
export const FooterListContainer = styled.div``
export const FooterListHeading = styled.p`
  color: var(--color-white);
  font-family: var(--font-heading);
  font-size: var(--font-size-footer-heading);
`
export const FooterList = styled.ul`
  margin: 2rem 0;

  font-family: var(--font-body);
  font-size: var(--font-size-footerlist);

  list-style: none;

  & li {
    margin: 0rem 0 1rem;
  }
`

export const FooterListItem = styled.li`
  margin: 0.5rem 0;
`
export const FooterExternalLink = styled.a`
  color: var(--color-white);

  text-decoration: none;
`
export const FooterInternalLink = styled(Link)`
  color: var(--color-white);
`

export const FooterBottomContainer = styled.div`
  display: grid;
  width: 100%;
  gap: 5rem;
  grid-template-columns: 1fr 1fr;

  ${media.tabport`
  gap: 3rem;
  grid-template-columns: 1fr;
  `}
`
